import StepDrawer from './StepDrawer';
import React, { useState } from "react";
import PrivacyControls from './PrivacyControls';
function PainDiaryPrivacy({
    currentStep,
    totalSteps,
    diary,
    setDiary,
    submit,
    close,
    back,
}) {
    const selectPublic = () => {
        setDiary(prev => {
            return {
                ...prev,
                public: true
            }
        })
    }

    const selectPrivate = () => {
        setDiary(prev => {
            return {
                ...prev,
                public: false
            }
        })
    }

    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            title={diary?.id ? "Edit Your Pain Diary" : "Create Your Pain Diary"}
            onContinue={submit}
            onCancel={close}
            onBack={back}
        >
            <PrivacyControls
                selectPrivate={selectPrivate}
                selectPublic={selectPublic}
                publicDescription="Setting your Pain Diary to Public will allow others to see how your recovery is going."
                privateDescription="Only you will be able to see your Pain Diary."
                isPublic={diary.public}
            />
        </StepDrawer>
    )
}

export default PainDiaryPrivacy;